import React, { useState } from 'react';

function StepTwo({ formData, onNext }) {
    const [hasUKPassport, setHasUKPassport] = useState(formData?.hasUKPassport || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!hasUKPassport) {
            setError('Please select Yes or No.');
            return;
        }

        setError('');
        onNext({ hasUKPassport });
    };

    return (
        <div className="step-form">
            <h6 className="mb-4">ID verification and right to work</h6>

            {error && <div className="alert alert-danger">{error}</div>}
                                <label className="form-label">Do you have a uk passport? <span className="text-danger">*</span></label>
            <div className="row">
                <div className="col-lg-6">
                    <div className="form-check mb-2">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="ukPassport"
                            id="ukPassportYes"
                            value="yes"
                            checked={hasUKPassport === 'yes'}
                            onChange={() => setHasUKPassport('yes')}
                        />
                        <label className="form-check-label" htmlFor="ukPassportYes">
                            Yes
                        </label>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="form-check mb-3">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="ukPassport"
                            id="ukPassportNo"
                            value="no"
                            checked={hasUKPassport === 'no'}
                            onChange={() => setHasUKPassport('no')}
                        />
                        <label className="form-check-label" htmlFor="ukPassportNo">
                            No
                        </label>
                    </div>
                </div>
            </div>

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!hasUKPassport}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default StepTwo;
